export default __webpack_public_path__ + "static/media/Leah_adjusted.fd10b4a7.png";